export default __webpack_public_path__ + "static/media/ReadindImage.16ec8cde.svg";